import React, { ChangeEvent, useEffect, useState } from "react";
import { GET_PRIV_END_POINT,UPDATE_PRIV_END_POINT } from "../../../../config/config";
import { api, getToken } from "../../../../services/apis/auth-api/apiUrl";
import AuthUpdateButton from "../../buttons/auth-button/updateAuthButton";
import { requestStatusProps } from "../../../../utils/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

interface UpdatePrivilegeProp {
    id : number,
    name : string
}

const UpdatePrivilege : React.FC<UpdatePrivilegeProp> = ({id, name}) => {
    
    const [priv, setPriv] = useState<number[]>([]);
    const [status, setStatus] = useState<requestStatusProps>({success : false, message : ''})
    const [loading, setLoading] = useState<boolean>(true);
    
    useEffect(()=>{
        async function getPriv() {
            try{
                const priv = await api.get(GET_PRIV_END_POINT+id, {
                    headers : {'Authorization' : 'Bearer '+getToken()}
                })
                if(priv) setPriv(priv.data);
                setLoading(false);
            }catch(e){
                setLoading(false);
            }
        }
        getPriv();
    },[id])

    const changePriv = (priv_id : number, e : ChangeEvent<HTMLInputElement>) =>{
        let updatedPriv;

        if(e.target.checked){
            updatedPriv = [...priv, priv_id];
        }else{
            updatedPriv = priv.filter((item)=> item !== priv_id)
        }

        setPriv(updatedPriv);
    }

    return (
        <div className="min-w-96 relative">
            <div className={loading ? 'modal-loader' : 'hidden'}>
                <FontAwesomeIcon className="animate-spin" icon={faSpinner} />
            </div>
            <div>
                Update {name}'s Page access
            </div>
            <div className="my-2">
                <div className={status.success ? 'text-green-600' : 'text-red-500'}>
                    {status.message}
                </div>
                <form>
                    <div className="flex">
                        <div>
                            <div>
                                <div className="input-container flex items-center gap-2">
                                    <input type="checkbox" checked={priv.includes(1)} onChange={(e)=>changePriv(1, e)} className="check-box" />
                                    <p>Manage Users</p>
                                </div>
                                <div className="input-container flex items-center gap-2">
                                    <input type="checkbox" checked={priv.includes(2)} onChange={(e)=>changePriv(2, e)} className="check-box" />
                                    <p>Manage Departments</p>
                                </div>
                                <div className="input-container flex items-center gap-2">
                                    <input type="checkbox" checked={priv.includes(5)} onChange={(e)=>changePriv(5, e)} className="check-box" />
                                    <p>Format CV</p>
                                </div>
                                <div className="input-container flex items-center gap-2">
                                    <input type="checkbox" checked={priv.includes(7)} onChange={(e)=>changePriv(7, e)} className="check-box" />
                                    <p>HR Management</p>
                                </div>
                                <div className="input-container flex items-center gap-2">
                                    <input type="checkbox" checked={priv.includes(8)} onChange={(e)=>changePriv(8, e)} className="check-box" />
                                    <p>Leave</p>
                                </div>
                                <div className="input-container flex items-center gap-2">
                                    <input type="checkbox" checked={priv.includes(11)} onChange={(e)=>changePriv(11, e)} className="check-box" />
                                    <p>Full access Pipeline</p>
                                </div>
                                <div className="input-container flex items-center gap-2">
                                    <input type="checkbox" checked={priv.includes(14)} onChange={(e)=>changePriv(14, e)} className="check-box" />
                                    <p>Full access Pipeline buttons</p>
                                </div>
                                <div className="input-container flex items-center gap-2">
                                    <input type="checkbox" checked={priv.includes(13)} onChange={(e)=>changePriv(13, e)} className="check-box" />
                                    <p>Revenue Tracker</p>
                                </div>
                            </div>
                        </div>
                        <div className="ms-40">
                            <div className="input-container flex items-center gap-2">
                                <input type="checkbox" checked={priv.includes(4)} onChange={(e)=>changePriv(4, e)} className="check-box" />
                                <p>Attendance</p>
                            </div>
                            <div className="input-container flex items-center gap-2">
                                <input type="checkbox" checked={priv.includes(3)} onChange={(e)=>changePriv(3, e)} className="check-box" />
                                <p>Manage JDL</p>
                            </div>
                            <div className="input-container flex items-center gap-2">
                                <input type="checkbox" checked={priv.includes(6)} onChange={(e)=>changePriv(6, e)} className="check-box" />
                                <p>Requirements</p>
                            </div>
                            <div className="input-container flex items-center gap-2">
                                <input type="checkbox" checked={priv.includes(9)} onChange={(e)=>changePriv(9, e)} className="check-box" />
                                <p>Leave Approval</p>
                            </div>
                            <div className="input-container flex items-center gap-2">
                                <input type="checkbox" checked={priv.includes(10)} onChange={(e)=>changePriv(10, e)} className="check-box" />
                                <p>CST Dashboard</p>
                            </div>
                            <div className="input-container flex items-center gap-2">
                                <input type="checkbox" checked={priv.includes(12)} onChange={(e)=>changePriv(12, e)} className="check-box" />
                                <p>CDD Pipeline</p>
                            </div>
                             <div className="input-container flex items-center gap-2">
                                <input type="checkbox" checked={priv.includes(15)} onChange={(e)=>changePriv(15, e)} className="check-box" />
                                <p>Candidates Profile</p>
                            </div>
                        </div>
                    </div>
                    <div className="w-full text-right my-2">
                       <AuthUpdateButton id={id} str_arr={JSON.stringify(priv)} onSubmit={(stat)=>setStatus(stat)} endpoint={UPDATE_PRIV_END_POINT} />
                    </div>
                </form>
            </div>
        </div>
    )
}

export default UpdatePrivilege;